module.exports = __webpack_public_path__ + "static/media/open.337c91c7.png";